export const HEADER_HEIGHT = 65;

export const METADATA_HEIGHT = 80;

export const EMAIL_MAX_LEN = 255;

export const LOGIN_REDIRECT_URL = '/';

export const PUBLIC_ENDPOINT = '/graphql/public';

export const REGISTER_ENDPOINT = '/graphql/public/register';

export const LOGIN_ENDPOINT = '/graphql/public/login';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FORCE_EXTERNAL =
  window.location.host === 'cloud.digitalocean.com' && !window.location.pathname.startsWith('/registration-next');

export const APOLLO_CLIENT_NAME = 'registration-next';

export const APOLLO_CLIENT_VERSION = '1.0';

export const NETWORK_ERROR_CODE = 403;

export const NETWORK_TOO_MANY_REQUESTS_CODE = 429;

export const CF_RAY_ID_REGEXP = /(Cloudflare Ray ID: (<strong>)?)([a-z|0-9]*)(<\/strong>)?/;

export const APP_PLATFORM_TEMPLATE_COOKIE = '_digitalocean_app_platform_url_after_activation';

export const REDIRECT_URL_PARAM = 'redirect_url';

export const ACTIVATION_REDIRECT_COOKIE = '_digitalocean_activation_redirect';

export const ACTIVATION_REDIRECT_PARAM = 'activation_redirect';

export const GITHUB_STUDENT_PACK_COOKIE = '_digitalocean_gh_student_pack';

export const GITHUB_STUDENT_PACK = 'github-student-pack';

export const ONBOARDING_ORIGIN_PARAM = 'onboarding_origin';

export const CHURN_SURVEY_URL = 'https://digitalocean.getfeedback.com/r/jgkIoAt5';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FLASH_ERROR_COOKIE_NAME = '_digitalocean_flash_error';

export const REGISTER_SHOW_OPTIONS_STEP = 0;
export const REGISTER_SHOW_FORM_STEP = 1;

export const LOGIN_VARIANTS_ENDPOINT = 'https://ui-managed-content.nyc3.digitaloceanspaces.com';

export const LOGIN_VARIANTS_FILE_BASE_PATH = '/LOGIN_VARIANTS';

export const PREVIEW_LOGIN_VARIANTS_PARAM = 'previewLoginVariants';
